import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { SESSION_NOTIFICATIONS } from '../../types/videocall.types';

interface SessionTiming {
  startTimestamp: number;
  sessionLength: number;
  bufferTime: number;
}

interface UseSessionNotificationsProps {
  sessionTiming: SessionTiming | null;
  endCall: () => void;
}

export const useSessionNotifications = ({ sessionTiming, endCall }: UseSessionNotificationsProps) => {
  const [fiveMinNotificationShown, setFiveMinNotificationShown] = useState(false);
  const [twoMinNotificationShown, setTwoMinNotificationShown] = useState(false);

  useEffect(() => {
    if (!sessionTiming) return;

    const checkTimeAndNotify = () => {
      const now = Date.now();
      const sessionEnd = sessionTiming.startTimestamp + sessionTiming.sessionLength * 60 * 1000;
      const finalEnd = sessionEnd + sessionTiming.bufferTime * 60 * 1000;

      if (sessionTiming.bufferTime > 0) {
        if (Math.abs(now - (sessionEnd - 5 * 60 * 1000)) < 1000 && !fiveMinNotificationShown) {
          toast.warning(SESSION_NOTIFICATIONS.FIVE_MINUTES.message, {
            position: 'top-left',
            richColors: true,
          });
          setFiveMinNotificationShown(true);
        }

        if (Math.abs(now - (finalEnd - 2 * 60 * 1000)) < 1000 && !twoMinNotificationShown) {
          toast.warning(SESSION_NOTIFICATIONS.TWO_MINUTES.message, {
            position: 'top-left',
            richColors: true,
          });
          setTwoMinNotificationShown(true);
        }
      }

      if (now >= finalEnd) {
        endCall();
      }
    };

    const timer = setInterval(checkTimeAndNotify, 1000);
    return () => clearInterval(timer);
  }, [sessionTiming, endCall, fiveMinNotificationShown, twoMinNotificationShown]);

  return {
    fiveMinNotificationShown,
    twoMinNotificationShown,
  };
};

export default useSessionNotifications;
